import React from 'react';
import { NavigationTabLink } from 'modules/ui';

export default function AgentProfileTabs() {
  return (
    <>
      <NavigationTabLink end to="/profile/edit">
        Personal Info
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/agency-info">
        Agency Info
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/social-media-links">
        Social Media
      </NavigationTabLink>
    </>
  );
}
